import { createFileRoute } from "@tanstack/react-router"

import { LegalVersionPage } from "@/components/content/legal-version-page"
import {
  currentLegalVersion,
  lazyLegalModules,
  loadCurrentLegalVersion,
  resolveLegalVersions,
} from "@/lib/legal-versions"
import { seoMeta } from "@/lib/seo"

const modules = lazyLegalModules(import.meta.glob("../-content/regions/*.md"))

export const Route = createFileRoute("/_content/regions/")({
  head: () =>
    seoMeta({
      title: "Hosting Regions",
      description: "The hosting regions customers can choose for their data on Entire.",
      url: "https://entire.com/regions",
      image: "https://entire.com/og/page/regions.png",
    }),
  loader: () => loadCurrentLegalVersion(modules),
  component: RegionsPage,
})

function RegionsPage() {
  const { asOf } = Route.useLoaderData()
  const versions = resolveLegalVersions(modules, asOf)
  const current = currentLegalVersion(versions)!
  return <LegalVersionPage basePath="/regions" version={current} versions={versions} />
}
